import { Link } from 'react-router-dom';
import { useT } from '../../i18n';
import { L } from '../tokens';
import { useViewportKind } from '../useViewport';

// Leo's "Reports (agent)": six cards, icon and name only. No period filter here: the period is chosen inside each report. The reports are one click from each other.
const Svg = ({ children }) => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke={L.accent} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
);

const CARDS = [
  { key: 'commissions', to: '/reports/commissions', icon: <Svg><circle cx="8" cy="8" r="6" /><path d="M18.09 10.37A6 6 0 1 1 10.34 18" /><path d="M7 6h1v4" /><path d="m16.71 13.88.7.71-2.82 2.82" /></Svg> },
  { key: 'discrepancies', to: '/reports/discrepancies', icon: <Svg><path d="M12 3.5 21 19.5H3z" /><path d="M12 10v4.5M12 17v.2" /></Svg> },
  { key: 'forecast', to: '/reports/forecast', icon: <Svg><path d="M3.5 17.5 9 12l3.5 3.5 7-8" /><path d="M15 7.5h5v5" /></Svg> },
  { key: 'suppliers', to: '/reports/suppliers', icon: <Svg><path d="M2.5 6.5h11v10h-11z" /><path d="M13.5 10h4l3 3.2v3.3h-7z" /><circle cx="7" cy="18" r="1.8" /><circle cx="17" cy="18" r="1.8" /></Svg> },
  { key: 'customers', to: '/reports/customers', icon: <Svg><circle cx="9" cy="8.5" r="3.2" /><path d="M3 20c.4-3.4 2.8-5.3 6-5.3s5.6 1.9 6 5.3" /><path d="M16 5.5a3 3 0 0 1 0 6M18.5 14.7c1.5.7 2.4 2.2 2.7 4.3" /></Svg> },
  { key: 'archive', to: '/reports/archive', icon: <Svg><rect x="3.5" y="4" width="17" height="4.5" rx="1" /><path d="M5 8.5V19a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.5M10 12.5h4" /></Svg> },
];

export default function ReportsHubView() {
  const t = useT();
  const vk = useViewportKind();
  const phone = vk === 'phone';
  return (
    <main data-testid="reports-hub" style={{ flexGrow: 1, boxSizing: 'border-box', padding: phone ? '20px 16px 104px' : '32px 48px 56px', maxWidth: 1240, width: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 22 }}>
      <h1 style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)', margin: 0 }}>{t('reports.title')}</h1>
      <div style={{ display: 'grid', gridTemplateColumns: phone ? 'repeat(2, minmax(0, 1fr))' : 'repeat(3, minmax(0, 1fr))', gap: phone ? 12 : 22 }}>
        {CARDS.map((c) => (
          <Link key={c.key} to={c.to} data-testid={`reports-card-${c.key}`}
            style={{ background: L.card, border: `1px solid ${L.border}`, borderRadius: 20, minHeight: phone ? 112 : 150, padding: '18px 16px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, textAlign: 'center', color: L.text, textDecoration: 'none' }}>
            <span style={{ width: 60, height: 60, borderRadius: 30, background: L.iconBg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>{c.icon}</span>
            <span style={{ fontFamily: L.serif, fontSize: phone ? 18 : 24, fontWeight: 500 }}>{t(`reports.card.${c.key}`)}</span>
          </Link>
        ))}
      </div>
    </main>
  );
}
